<template>
        <section class="headbar">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="16" offset-md="0">
                        <h1 class="section-title">Týmová hra o skvělé ceny!</h1>
                        <v-row>
                            <v-col cols="12" offset="2" sm="10" offset-sm="3">
                                <p class="headbar__text">Postav si svůj tým a&nbsp;hraj s&nbsp;kamarády o&nbsp;den v&nbsp;pivovaru Staropramen se&nbsp;sládkem <nobr>a poukazy</nobr> do&nbsp;hospody v&nbsp;celkové hodnotě více než 1 000 000 Kč.</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-center" cols="14" offset="1" md="6" offset-md="5" sm="8" offset-sm="4">
                                <v-btn
                                    color="primary"
                                    large
                                    dark
                                    text
                                    :to="{ name: 'registration' }"
                                >Registrace</v-btn>
                                <v-btn
                                    color="primary"
                                    large
                                    dark
                                    text
                                    :to="{ name: 'home', hash: '#mapa-hospod' }"
                                >Mapa hospod</v-btn>
                                <div class="headbar__scroll">
                                    <a href="#o-co-hrajeme" tag="span" style="cursor: pointer">
                                        <img src="/img/scroll2.svg">
                                    </a>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
</template>

<script>
    export default {
        name: 'HeadbarBlock',
    }
</script>

